// Import icons
import ClickToPay from '@/assets/img/payment-types/c2p.svg';
import PaymentTypes from '@/models/PaymentTypes';


export default {
    namespaced: true,

    state: {
        Types: [
            {
                Id: PaymentTypes.CLICK_TO_PAY,
                WalletName: 'ClickToPay',
                Title: 'clickToPayModalTitle',
                Icon: ClickToPay,
                StartView: 'UserValidationC2P',
                Text: 'clickToPayWithSavedCard',
                IsNew: false,
                LogCategory: 'click_to_pay',
                LogAction: 'forma_pagamento_c2p',
                LogLabel: 'Usuário escolhe a forma de pagamento expressa - clicando no batao do Click to Pay.',
                Available: false,
            },
        ],

        /**
         * Payment types that are mapped from the preorder get response.
         */
        TypesFromPreorder: []
    },

    mutations: {
        /**
         * Map the api response to the module
         */
        setFromRequest(state, data) {
            state.TypesFromPreorder = data.WalletMethodInformation || [];
        }
    },

    getters: {
        /**
         * Retorna todos os tipos de pagamento
         */
        getAll: state => state.Types,

        /**
         * Retorna os tipos de pagamento de wallet para a loja
         */
        getAvailable(state, getters, rootState, rootGetters) {
            return state.Types.filter(type => {
                const matchedTypeFromPreorder = state.TypesFromPreorder.find(typeFromPreorder => typeFromPreorder.Name === type.WalletName);
                if (!matchedTypeFromPreorder) {
                    return false;
                }
        
                switch (type.WalletName) {
                case 'ClickToPay':
                    return type.Available = rootState.clickToPayPayment.isClickToPayEnabled && rootState.clickToPayPayment.initialized;
              
                    // Add more cases as needed
                default:
                    return type.Available;
                }
            });
        }
    }
};
